export default "__VITE_ASSET__7957261e__"